import { z } from "zod";

const tariffFamilySchema = z.enum(["white", "black"]);
const tariffTierSchema = z.enum(["basic", "pro"]);
const subscriptionStatusSchema = z.enum(["active", "inactive"]);

export const subscriptionResponseSchema = z.object({
  id: z.string(),
  tariff_family: tariffFamilySchema,
  tariff_tier: tariffTierSchema,
  status: subscriptionStatusSchema,
  expires_at: z.string(),
  traffic_used_bytes: z.number(),
  traffic_limit_bytes: z.number(),
  traffic_resets_at: z.string(),
  vless_uuid: z.string(),
  hy2_password: z.string().nullable(),
  external_id: z.string().nullable(),
  sub_link: z.string().nullable(),
  flame_sub_token: z.string().nullable().optional(),
  flame_sub_url: z.string().nullable().optional(),
  hy2_urls: z.array(z.string()).optional(),
  created_at: z.string(),
  updated_at: z.string(),
});

export const subscriptionListResponseSchema = z.object({
  items: z.array(subscriptionResponseSchema),
});
